// ワークフロー一覧種別
export enum WorkflowDisplayKinds {
  None,
  RequestList,
  WorkflowList,
  TodoList,
  ManagerHistoryList,
}
